// Shared auth check — deduplicates the /api/data/me fetch across sync hooks.
// One fetch per page load; all callers await the same promise.
let _authPromise: Promise<boolean> | null = null

export function checkAuthOnce(): Promise<boolean> {
  if (!_authPromise) {
    _authPromise = fetch('/api/data/me')
      .then(r => r.json())
      .then((me: { authenticated?: boolean }) => !!me.authenticated)
      .catch(() => false)
  }
  return _authPromise
}
